import {manipulateAsync, SaveFormat} from 'expo-image-manipulator'

import {type ImageMeta} from '#/state/gallery'

const VALID_PROFILE_IMAGE_MIMES = new Set(['image/jpeg', 'image/png'])

export async function ensureValidProfileImage(
  image: ImageMeta,
): Promise<ImageMeta> {
  if (VALID_PROFILE_IMAGE_MIMES.has(image.mime)) {
    return image
  }

  const result = await manipulateAsync(image.path, [], {
    compress: 1,
    format: SaveFormat.JPEG,
  })

  return {
    path: result.uri,
    width: result.width,
    height: result.height,
    mime: 'image/jpeg',
  }
}
